export default "__VITE_ASSET__C3QX9JqN__"